module.exports = __webpack_public_path__ + "static/media/business1.5a623860.png";